import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams, OpalApiResponseDocument } from '../../schema'

type Params = OpalApiRequestParams<'GetBlockDuplicationV3'>
type Response = OpalApiResponseDocument<'GetBlockDuplicationV3', 200>

export const readBlockDuplication = (params: Params) => {
  const url = new URL(
    `/loupe/v3/block_duplications/${params.path.block_duplication_id}`,
    window.location.origin
  )

  return HttpClient()
    .get<Response>(url.toString())
    .then((res) => res.data)
}
